module.exports = __webpack_public_path__ + "img/heart.1cb6f5b9.svg";